<template>
  <v-container>
    <div v-if="!overlay">
      <div v-if="!examQuestions[0]" class="text-center pa-4">
        <img src="../../assets/document.svg" width="200px" />
        <h3>{{ $t("exam.ThereAreNoQuestions") }}</h3>
      </div>
      <v-row>
        <v-col>
          <v-btn :disabled="isActive" color="primary" large block @click="openAddQuestion"
            >{{ $t("exam.AddAQuestion") }}
            <v-icon> mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>


      <v-row v-for="item in examQuestions" :key="item.questionGuid" >
      
        <v-col cols="12" md="12">
          <v-card class="mx-auto" flat outlined>
            <v-card-text>
              <question-title :examQuestion="item"></question-title>

              <!-- MultiChoice MultiChoice MultiChoice MultiChoice MultiChoice MultiChoice MultiChoice MultiChoice  -->
              <div class="text--primary" v-if="item.questionType === 'MultiChoice'">
                <v-alert outlined color="primary" text>
                  <div v-for="multeItem in item.questionAnswers" :key="multeItem.answerGuid">
                    <v-checkbox
                      readonly
                      v-model="multeItem.isCorrect"
                      :label="multeItem.questionAnswer"
                      :value="multeItem.isCorrect"
                      :color="multeItem.isCorrect ? 'success' : 'error'"
                    >
                    </v-checkbox>
                  </div>
                </v-alert>
              </div>
              <!-- OneChoice OneChoice OneChoice OneChoice OneChoice OneChoice OneChoice OneChoice OneChoice  -->
              <div class="text--primary" v-if="item.questionType === 'OneChoice'">
                <v-alert outlined color="primary" text>
                  <div v-for="oneChoesVal in item.questionAnswers" :key="oneChoesVal.answerGuid">
                    <v-radio-group
                      v-if="oneChoesVal.isCorrect"
                      v-model="oneChoesVal.questionAnswer"
                    >
                      <v-radio
                        readonly
                        v-for="oneChoesItem in item.questionAnswers"
                        :key="oneChoesItem.answerGuid"
                        :label="oneChoesItem.questionAnswer"
                        :value="oneChoesItem.questionAnswer"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </v-alert>
              </div>
              <!-- FillInTheBlanks FillInTheBlanks FillInTheBlanks FillInTheBlanks FillInTheBlanks FillInTheBlanks -->
              <div class="text--primary" v-if="item.questionType === 'FillInTheBlanks'">
                <v-alert outlined color="primary" text>
                  {{ item.questionAnswers[0].questionAnswer }}
                </v-alert>
              </div>
              <!-- Number Number Number Number Number Number Number Number Number Number Number Number Number Number -->
              <div class="text--primary" v-if="item.questionType === 'Number'">
                <v-alert outlined color="primary" text>
                  {{ item.questionAnswers[0].questionAnswer }}
                </v-alert>
              </div>
              <!-- AttachedFile AttachedFile AttachedFile AttachedFile AttachedFile AttachedFile AttachedFile AttachedFile  -->
              <div class="text--primary" v-if="item.questionType === 'AttachedFile'">
                <v-alert outlined color="primary" text>
                  <download-file
                    v-if="item.studentAnswers[0]"
                    :fileUrl="item.fileUrl"
                  ></download-file>

                  <p v-else class="pt-2 error--text">
                    {{ $t("exam.NoFileSent") }}
                  </p>
                </v-alert>
              </div>
            </v-card-text>
            <v-card-actions class="mx-2 mb-3">
              <v-btn outlined color="teal" @click="editQuestion(item)" :disabled="isActive">
                {{ $t("edit") }}
                <v-icon>mdi-file-edit-outline</v-icon>
              </v-btn>
              <v-btn
                outlined
                color="error"
                @click="deleteQuestion(item.questionGuid)"
                :disabled="isActive"
              >
                {{ $t("delete") }}
                <v-icon>mdi-delete-forever-outline</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
     
      </v-row>


    </div>
 
    <AddQuestion
      ref="addQuestionComponent"
      v-on:send-result-values="sendResultValues"
    ></AddQuestion>
  </v-container>
</template>

<script>
import AddQuestion from "./addQuestion.vue";
import DownloadFile from "../downloadFile.vue";
import QuestionTitle from "./questionTitle.vue";

export default {
  components: {
    AddQuestion,
    DownloadFile,
    QuestionTitle
  },
  props: ["examQuestions", "examGuid", "isActive"],
  data() {
    return {
      overlay: false
    };
  },
  methods: {
    deleteQuestion(item) {
      this.$swal
        .fire({
          title: this.$t("AreYouSureAboutTheOperation"),
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("no")
        })
        .then(result => {
          if (result.value) {
            this.axios
              .delete(`Exams/DeleteQuestion?questionGuid=${item}`)
              .then(res => {
                if (res.data.statusCode == 1) {
                  this.sendResultValues();
                  this.$swal.fire({
                    title: this.$t("operationAccomplishedSuccessfully"),
                    text: "",
                    icon: "success",
                    confirmButtonText: this.$t("close"),
                    toast: true,
                    position: "bottom-start",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: toast => {
                      toast.addEventListener("mouseenter", this.$swal.stopTimer);
                      toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                    }
                  });
                } else if (res.data.statusCode == 2) {
                  this.$swal.fire({
                    title: this.$t("errors.YouCanNotDeleteTheQuestionTheExamIsActiv"),
                    text: "",
                    icon: "error",
                    confirmButtonText: this.$t("close")
                  });
                  this.$emit("send-result-values", "carrier");
                } else if (res.data.statusCode == 3) {
                  this.$swal.fire({
                    title: this.$t("errors.ExamNotFound"),
                    text: "",
                    icon: "error",
                    confirmButtonText: this.$t("close")
                  });
                  this.$emit("send-result-values", "carrier");
                } else if (res.data.statusCode == 4) {
                  this.$swal.fire({
                    title: this.$t("errors.YouCanNotDeleteTheQuestionItHasBeenAnsweredByTheStudents"),
                    text: "",
                    icon: "error",
                    confirmButtonText: this.$t("close")
                  });
                  this.$emit("send-result-values", "carrier");
                } else {
                  this.$swal.fire({
                    title: this.$t("errors.AnErrorOccurredTheOperationDidNotCompleteSuccessfully"),
                    text: "",
                    icon: "error",
                    confirmButtonText: this.$t("close")
                  });
                  this.$emit("send-result-values", "carrier");
                }
                // console.log(res);
              })
              .catch(() => {
                this.$swal.fire({
                  title: this.$t("AnErrorOccurredDuringTheProcess"),
                  text: "",
                  icon: "error",
                  confirmButtonText: this.$t("close")
                });
              });
          }
        });
    },
    editQuestion(item) {
      // console.log(item);
      this.$refs.addQuestionComponent.editValue(this.examGuid, item);
    },
    downloadFileAttachment(item) {
      window.open(`${item.fileUrl}`);
      return;

      this.axios({
        url: `${item.fileUrl}`,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.data.type
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = item.question;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(() => {
          this.$swal.fire({
            title: this.$t("TheFileDoesNotExist"),
            text: "",
            icon: "error",
            confirmButtonText: this.$t("close")
          });
        });
    },
    get_url_extension(url) {
      return url
        .split(/[#?]/)[0]
        .split(".")
        .pop()
        .trim()
        .toLowerCase();
    },
    openAddQuestion() {
      this.$refs.addQuestionComponent.setValue(this.examGuid);
    },
    sendResultValues() {
      this.$emit("send-result-values", "carrier");
    }
  },
  created() {}
};
</script>

<style></style>
